/**
 * count the number of times the needle occurs within the haystack.
 */
function countTextOccurrences(haystack, needle) {
  if (haystack.length < needle.length) {
    // give up if the haystack is smaller than the needle - there's no possible
    // way there could be any matches anyway
    return 0;
  }
  if (needle.length === 0) {
    // give up if there's no needle given, we cannot count occurrences in that
    // case anyway
    return 0;
  }
  let occurrences = 0;
  let pos = 0;
  do {
    pos = haystack.indexOf(needle, pos);
    if (pos > -1) {
      occurrences++;
      pos += needle.length;
    }
  } while (pos > -1);
  return occurrences;
}

export { countTextOccurrences };
//# sourceMappingURL=countTextOccurrences.js.map
